module.exports = __webpack_public_path__ + "static/media/app-icon.4de08059.png";